import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCachedFetch } from '../../../hooks/useCachedFetch';
import './BannerSkeleton.scss';

const BannerSkeleton = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const location = useLocation();

  const [shouldShow, setShouldShow] = useState(false);

  const { data: promoData, loading, error } = useCachedFetch('/data/locales/promo.json');

  useEffect(() => {
    if (loading) return;
    if (error) {
      console.error('Error checking banner data for skeleton:', error);
      setShouldShow(false);
      return;
    }

    const data = promoData?.comingSoonData;

    if (data && data.length > 0) {
      const latest = data.reduce(
        (prev, curr) => (curr.comingSoonId > prev.comingSoonId ? curr : prev),
        data[0]
      );

      const bannerData = latest?.bannerData?.[currentLang] || latest?.bannerData?.en;

      const hasBannerData = bannerData && bannerData.BannerText && latest;

      if (hasBannerData) {
        const path = location.pathname;
        const comingSoonPath = `/${currentLang}/coming-soon`;
        const promoPath = `/${currentLang}/promo/`;

        const shouldHide = 
          path.includes(latest.slug) || 
          path.startsWith(comingSoonPath) || 
          path.startsWith(promoPath);
        
        setShouldShow(!shouldHide);
      } else {
        setShouldShow(false);
      }
    } else {
      setShouldShow(false);
    }
  }, [promoData, loading, error, currentLang, location.pathname]);

  if (!shouldShow) {
    return null;
  }

  return (
    <div className="hidden__banner__skeleton"></div>
  );
};

export default BannerSkeleton;